import * as React from 'react';

const CustomToggleSwitch = React.memo(({
    leftText,
    rightText,
    toggleWidth,
    disabled,
    setAlignment,
    alignment,
    onLeftClick,
    onRightClick,
    leftCount,
    RightCount,

}) => {
    const handleLeftClick = () => {
        if (!disabled && alignment !== leftText) {
            setAlignment(leftText);
            onLeftClick?.();
        }
    };

    const handleRightClick = () => {
        if (!disabled && alignment !== rightText) {
            setAlignment(rightText);
            onRightClick?.();
        }
    };

    return (
        <div
            className={`flex ml-2 items-center h-8 md:!h-[38px] ${toggleWidth ? "w-[300px]" : "w-[6rem] md:!w-[10rem]"
                } overflow-hidden bg-[#DFE0EB] rounded-xl`}
        >
            <div
                onClick={handleLeftClick}
                className={`flex text-xs md:text-base h-[40px] justify-center flex-1 items-center ${alignment == leftText
                        ? "rounded-tl-[10px] rounded-tr-[10px] rounded-br-[10px] text-[#fff] bg-[#007bff] cursor-default"
                        : "rounded-tl-none rounded-tr-none rounded-br-none text-[#706d67] bg-[#DFE0EB] cursor-pointer"
                    }`}
            >
                {leftText} ({leftCount ? leftCount : 0})
            </div>
            <div
                onClick={handleRightClick}
                className={`flex text-xs md:text-base h-[40px] justify-center flex-1 items-center ${alignment == rightText
                        ? "rounded-tl-[10px] rounded-tr-[10px] rounded-bl-[10px] text-[#fff] bg-[#007bff] cursor-default"
                        : "rounded-tl-none rounded-tr-none rounded-bl-none text-[#706d67] bg-[#DFE0EB] cursor-pointer"
                    }`}
            >
                {rightText} ({RightCount ? RightCount : 0})
            </div>
        </div>
    );
});

export default CustomToggleSwitch;